const nl = {
  meta: {
    home: {
      title: 'Manifestify | App voor Manifesteren & Affirmaties',
      description:
        'Manifestify is een app voor manifesteren en dagelijkse affirmaties voor iOS en Android. Maak je persoonlijke manifest, stel intenties, bouw vision boards en ontrafel je dromen met AI.',
    },
    blog: {
      title: 'Manifestatie Blog: Affirmaties, Gidsen & Methodes',
      description:
        'Deskundige gidsen over manifesteren: dagelijkse affirmaties, de 369-methode, vision boards, scripting en droomuitleg. Nieuwe artikelen van het Manifestify-team.',
    },
    notFound: {
      title: 'Pagina niet gevonden | Manifestify',
      description: 'De pagina die je zoekt bestaat niet.',
    },
    terms: {
      title: 'Algemene Voorwaarden | Manifestify',
      description: 'De algemene voorwaarden voor het gebruik van de Manifestify-app en -website.',
    },
    privacy: {
      title: 'Privacybeleid | Manifestify',
      description: 'Hoe Manifestify je persoonsgegevens verzamelt, gebruikt en beschermt.',
    },
  },

  nav: {
    brandAria: 'Manifestify startpagina',
    mainAria: 'Hoofdnavigatie',
    blog: 'Blog',
    getApp: 'Download de app',
    languageAria: 'Taal wijzigen',
    languageLabel: 'Taal',
  },

  store: {
    downloadOn: 'Download in de',
    appStore: 'App Store',
    getItOn: 'ONTDEK HET OP',
    googlePlay: 'Google Play',
    appleAria: 'Download Manifestify in de App Store',
    googleAria: 'Ontdek Manifestify op Google Play',
  },

  home: {
    hero: {
      titleLine1: 'Manifesteer je dromen, elke dag.',
      titleAccent: 'Met Manifestify!',
      subtitle:
        'De manifestatie-app die je praktijk levend houdt: dagelijkse affirmaties, een persoonlijk manifest, vision boards, intenties en droomuitleg met AI — allemaal op één plek. Herhaal. Geloof. Word.',
      note: 'Gratis te downloaden · iOS en Android',
    },
    features: {
      titlePre: 'Alles wat je nodig hebt om te ',
      titleAccent: 'manifesteren',
      titlePost: '',
      subtitle:
        'Eén app voor je hele praktijk, van je eerste affirmatie in de ochtend tot het ontrafelen van de droom van gisternacht.',
      items: [
        {
          title: 'Dagelijkse affirmaties',
          text: 'Honderden zorgvuldig geschreven affirmaties over liefde, geld, gezondheid, zelfvertrouwen en innerlijke rust, elke dag bij je bezorgd.',
        },
        {
          title: 'Persoonlijk manifest',
          text: 'Maak van je doelen een persoonlijk manifest dat je dagelijks leest en versterkt, zodat je dromen voor je blijven staan.',
        },
        {
          title: 'Intenties stellen',
          text: 'Stel heldere dagelijkse intenties en laat de app je verankeren aan wat er echt toe doet.',
        },
        {
          title: 'Vision board',
          text: 'Bouw een digitaal vision board van het leven dat je aan het creëren bent en visualiseer het overal, altijd.',
        },
        {
          title: 'Droomuitleg met AI',
          text: 'Beschrijf je droom en ontdek de verborgen boodschappen met doordachte, AI-gestuurde inzichten.',
        },
        {
          title: 'Energiekaarten',
          text: 'Trek elke dag een energiekaart: een moment van reflectie en een frisse dosis inspiratie.',
        },
        {
          title: 'Dagelijkse herinneringen',
          text: 'Zachte meldingen op de tijden die jij kiest, zodat je praktijk nooit afhangt van geheugen of motivatie.',
        },
        {
          title: "Thema's & achtergronden",
          text: "Prachtige thema's en achtergronden die je praktijk persoonlijk en inspirerend maken.",
        },
      ],
    },
    how: {
      titlePre: 'Hoe het ',
      titleAccent: 'werkt',
      titlePost: '',
      steps: [
        {
          title: 'Stel je intentie',
          text: 'Kies wat je wilt manifesteren en bouw je persoonlijke manifest uit honderden zorgvuldig gekozen affirmaties.',
        },
        {
          title: 'Oefen dagelijks',
          text: 'Herhaal je affirmaties, visualiseer je vision board en trek je energiekaart. Herinneringen houden je reeks in leven.',
        },
        {
          title: 'Geloof en word het',
          text: 'Zie je focus, je zelfvertrouwen en je keuzes verschuiven naarmate je praktijk zich dag na dag opstapelt.',
        },
      ],
    },
    blogTeaser: {
      titlePre: 'Leer de kunst van ',
      titleAccent: 'manifesteren',
      titlePost: '',
      subtitle: 'Gidsen en technieken van het Manifestify-team, geschreven voor echte dagelijkse praktijk.',
      viewAll: 'Bekijk alle artikelen →',
    },
    faq: {
      titlePre: 'Veelgestelde ',
      titleAccent: 'vragen',
      titlePost: '',
      items: [
        {
          q: 'Wat is Manifestify?',
          a: 'Manifestify is een app voor manifesteren en dagelijkse affirmaties voor iOS en Android. De app brengt je hele praktijk samen: affirmaties in categorieën als liefde, carrière, overvloed en zelfvertrouwen, een persoonlijk manifest, intenties stellen, een vision board, dagelijkse herinneringen, energiekaarten en droomuitleg met AI.',
        },
        {
          q: 'Is Manifestify gratis?',
          a: 'Ja. Manifestify is gratis te downloaden en te gebruiken in zowel de App Store als Google Play. Optionele premium-abonnementen ontgrendelen de volledige affirmatiebibliotheek en geavanceerde functies zoals onbeperkte droomuitleg met AI.',
        },
        {
          q: 'Wat is manifesteren?',
          a: 'Manifesteren is de praktijk waarbij je je doelen werkelijkheid maakt door gerichte aandacht, positief geloof en consistente actie. Technieken zijn onder meer dagelijkse affirmaties, visualisatie, vision boards, scripting en de 369-methode.',
        },
        {
          q: 'Hoe werken dagelijkse affirmaties?',
          a: 'Affirmaties zijn korte, positieve zinnen in de tegenwoordige tijd die je elke dag herhaalt. In de loop van weken hervormen ze je innerlijke dialoog en trainen ze je aandacht richting kansen die aansluiten bij je doelen. Consistentie is de sleutel, en daarom heeft Manifestify dagelijkse herinneringen.',
        },
        {
          q: 'Is Manifestify beschikbaar op iPhone en Android?',
          a: 'Ja. Manifestify is beschikbaar voor iPhone en iPad in de App Store, en voor Android-apparaten op Google Play.',
        },
        {
          q: 'Hoe werkt de droomuitleg met AI?',
          a: 'Je beschrijft je droom in de app en Manifestify analyseert de symbolen, emoties en thema\'s om je meteen een doordachte uitleg te geven die je met je eigen context kunt verfijnen.',
        },
      ],
    },
    download: {
      title: 'Begin vandaag met manifesteren',
      text: 'Sluit je aan bij de mensen die elke ochtend met intentie beginnen. Download Manifestify gratis en bouw een praktijk die blijft.',
    },
  },

  blog: {
    titlePre: 'De Manifestify ',
    titleAccent: 'Blog',
    titlePost: '',
    subtitle:
      'Praktische gidsen over manifesteren, affirmaties, visualisatie en droomuitleg. Alles wat je nodig hebt om een dagelijkse praktijk te bouwen die werkt.',
    schemaName: 'De Manifestify Blog',
    schemaDescription:
      'Gidsen over manifesteren, dagelijkse affirmaties, vision boards, scripting en droomuitleg.',
    readTime: '{n} min leestijd',
  },

  post: {
    breadcrumbAria: 'Kruimelpad',
    home: 'Home',
    blog: 'Blog',
    ctaTitle: 'Breng het in praktijk met Manifestify',
    ctaText:
      'Dagelijkse affirmaties, een persoonlijk manifest, vision boards, intenties en droomuitleg met AI. Je hele manifestatiepraktijk in één gratis app.',
    faqTitle: 'Veelgestelde vragen',
    relatedTitle: 'Lees verder',
    relatedAria: 'Gerelateerde artikelen',
  },

  notFound: {
    text: 'Deze pagina bestaat niet, maar je dromen wel.',
    backHome: 'Terug naar home',
    readBlog: 'Lees de blog',
  },

  footer: {
    tagline:
      'Manifesteer je dromen, elke dag. Affirmaties, intenties, vision boards en droomuitleg in één app.',
    exploreTitle: 'Ontdekken',
    exploreAria: 'Ontdekken',
    home: 'Home',
    blog: 'Blog',
    downloadTitle: 'Download de app',
    downloadAria: 'Downloaden',
    appStoreLink: 'iPhone & iPad (App Store)',
    playStoreLink: 'Android (Google Play)',
    legalTitle: 'Juridisch',
    legalAria: 'Juridisch',
    terms: 'Algemene Voorwaarden',
    privacy: 'Privacybeleid',
    copyright: '© {year} Manifestify van Portal Studio. Alle rechten voorbehouden.',
  },

  legal: {
    back: 'Terug',
    translationNotice:
      'Deze vertaling wordt aangeboden voor het gemak. De juridisch bindende versie van dit document is de Engelse.',
    lastUpdated: 'Laatst bijgewerkt: {date}',
  },
};

export default nl;
